import React from 'react';
import { useCart } from '../../context/CartContext';
import ProductCard from './ProductCard';

const WishlistView = ({ layout }) => {
  const { wishlist } = useCart();

  if (wishlist.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 space-y-3">
        <p className="text-foreground-muted text-lg">Your wishlist is empty</p>
        <p className="text-sm text-foreground-secondary">Heart items while browsing to save them here.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-2xl font-bold text-foreground-primary mb-6">Wishlist</h2>
      {layout === 'grid' ? (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {wishlist.map((p) => <ProductCard key={p.id} product={p} layout="grid" />)}
        </div>
      ) : (
        <div>
          {wishlist.map((p) => <ProductCard key={p.id} product={p} layout="list" />)}
        </div>
      )}
    </div>
  );
};

export default WishlistView;
